import { TileViewModes } from 'generated/graphql-types';
import { DashboardTileUnionType } from '../../dashboard/models/dashboard-tile.model';

export function getTileViewMode(
   dashboardTile: DashboardTileUnionType,
   isFullscreen = false,
   forceRecalculation = false
): TileViewModes {
   const bounds = dashboardTile?.tile?.tileViewModeBound;

   if (bounds) {
      /**
       * The recalculation is needed for when the layout is updated only on the frontend.
       * I.E. on a breakpoint change, a new layout is created, mapping the layout configurations
       * to fit in the new column count. These new configurations are not saved so the tileViewMode
       * on the DashboardTile needs to be recalculated on the frontend since the backend calculation
       * could potentially be incorrect.
       */
      if (forceRecalculation) {
         const heightUpperBound = bounds!.heightUpperBound ?? Infinity;
         const heightLowerBound = bounds!.heightLowerBound ?? -1;
         const widthUpperBound = bounds!.widthUpperBound ?? Infinity;
         const widthLowerBound = bounds!.widthLowerBound ?? -1;

         if (
            dashboardTile.dashboardTileLayoutConfiguration.width < widthLowerBound ||
            dashboardTile.dashboardTileLayoutConfiguration.height < heightLowerBound
         )
            return TileViewModes.Small;

         if (
            dashboardTile.dashboardTileLayoutConfiguration.width >= widthUpperBound &&
            dashboardTile.dashboardTileLayoutConfiguration.height >= heightUpperBound
         )
            return TileViewModes.Large;

         return TileViewModes.Medium;
      }

      if (isFullscreen)
         return bounds.heightUpperBound || bounds.widthUpperBound ? TileViewModes.Large : TileViewModes.Medium;
   }

   return dashboardTile?.viewMode ?? TileViewModes.Medium;
}
